module.exports = __webpack_public_path__ + "static/media/close-icon.c0b20972.svg";